import axiosInstance from '@/lib/api/axios-instance';
import { ENDPOINTS } from '@/lib/api/endpoints';
import type { NotificationListResponse, UnreadCountResponse } from '../types/notification.types';

class NotificationService {
  async getNotifications(params?: { page?: number; limit?: number; isRead?: boolean }) {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set('page', String(params.page));
    if (params?.limit) searchParams.set('limit', String(params.limit));
    if (params?.isRead !== undefined) searchParams.set('isRead', String(params.isRead));

    const query = searchParams.toString();
    const url = query ? `${ENDPOINTS.NOTIFICATIONS}?${query}` : ENDPOINTS.NOTIFICATIONS;
    const response = await axiosInstance.get<NotificationListResponse>(url);
    return response.data;
  }

  async getUnreadCount() {
    const response = await axiosInstance.get<UnreadCountResponse>(
      ENDPOINTS.NOTIFICATIONS_UNREAD_COUNT
    );
    return response.data;
  }

  async markAsRead(id: string) {
    const response = await axiosInstance.patch(ENDPOINTS.NOTIFICATION_READ(id));
    return response.data;
  }

  async markAllAsRead() {
    const response = await axiosInstance.patch(ENDPOINTS.NOTIFICATIONS_READ_ALL);
    return response.data;
  }

  async deleteNotification(id: string) {
    const response = await axiosInstance.delete(ENDPOINTS.NOTIFICATION_DELETE(id));
    return response.data;
  }
}

export const notificationService = new NotificationService();
